import {
    Component, ElementRef, Input, QueryList, ViewChildren,
    ViewEncapsulation
} from '@angular/core';
import { ButtonTriggerEvent } from '../../../common/components';
import { ModalService } from '../../../common/services/modal.service';
import { UpgradeModalComponent } from '../upgrade.modal/upgrade.modal.component';
import { UpgradeModalActions } from '../upgrade.modal/upgrade.modal.provider';

@Component({
    selector: 'upgrade-button',
    templateUrl: './upgrade.button.component.html',
    styleUrls: ['./upgrade.button.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class UpgradeButtonComponent {
    @Input() public show = false;
    @Input() public isSimple = false;
    @Input() public css = '';
    @ViewChildren('card') card: QueryList<ElementRef>;

    constructor(private modalService: ModalService) {
    }

    public showUpgradeModal() {
        let actions = <UpgradeModalActions>{
            confirm: (event: ButtonTriggerEvent) => {
            }
        };

        this.modalService.show({
            component: UpgradeModalComponent,
            providers: [
                {provide: UpgradeModalActions, useValue: actions},
            ],
        });
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/upgrade.button/upgrade.button.component.ts